import { FormattedMessage } from 'react-intl';

const UserDetail = ({ id, value }) => {
  return (
    <div className="d-flex align-items-center">
      <span className="fw-bold">
        <FormattedMessage id={id} />
        :&nbsp;&nbsp;
      </span>
      <span>{value}</span>
    </div>
  );
};

export default UserDetail;
